export default __webpack_public_path__ + "78584af997a01b7328311fe69967c78e.jpg";